export type CrawlerCompetition = {
  name: string;
  slug: string;
};

const topLeagues: CrawlerCompetition[] = [
  {
    name: 'Regionalliga Bayern',
    slug: 'regionalliga-bayern',
  },
  {
    name: 'Regionalliga West',
    slug: 'regionalliga-west',
  },
  {
    name: 'Regionalliga Südwest',
    slug: 'regionalliga-suedwest',
  },
  {
    name: 'Regionalliga Nordost',
    slug: 'regionalliga-nordost',
  },
  {
    name: 'Regionalliga Nord',
    slug: 'regionalliga-nord',
  },
];

const topCups: CrawlerCompetition[] = [
  {
    name: 'Bayerischer Totopokal',
    slug: 'bayerischer-totopokal',
  },
  {
    name: 'Niederrheinpokal',
    slug: 'niederrheinpokal',
  },
  {
    name: 'Mittelrheinpokal',
    slug: 'mittelrheinpokal',
  },
  {
    name: 'Hessenpokal',
    slug: 'hessenpokal',
  },
  {
    name: 'Westfalenpokal',
    slug: 'westfalenpokal',
  },
  {
    name: 'Saarlandpokal',
    slug: 'sparkassenpokal-saarland',
  },
  {
    name: 'Rheinlandpokal',
    slug: 'rheinlandpokal',
  },
  {
    name: 'Südbadischer Pokal',
    slug: 'sbfv-rothaus-pokal',
  },
  {
    name: 'Badischer Pokal',
    slug: 'badischer-pokal',
  },
  {
    name: 'WFV-Pokal',
    slug: 'wfv-pokal',
  },
  {
    name: 'Südwestdeutscher Pokal',
    slug: 'verbandspokal-suedwest',
  },
  {
    name: 'Landespokal Sachsen-Anhalt',
    slug: 'landespokal-sachsen-anhalt',
  },
  {
    name: 'Sachsenpokal',
    slug: 'sachsenpokal',
  },
  {
    name: 'Berlin Pokal',
    slug: 'berlin-pokal',
  },
  {
    name: 'Brandenburg-Pokal',
    slug: 'landespokal-brandenburg',
  },
  {
    name: 'Landespokal Schleswig-Holstein',
    slug: 'shfv-pokal',
  },
  {
    name: 'Thüringen-Pokal',
    slug: 'tfv-landespokal',
  },
  {
    name: 'Niedersachsenpokal 3. Liga & Regionalliga',
    slug: 'niedersachsenpokal-3-liga-regionalliga',
  },
  {
    name: 'Niedersachsenpokal der Amateure',
    slug: 'niedersachsenpokal',
  },
  {
    name: 'Mecklenburg-Vorpommern-Pokal',
    slug: 'mecklenburg-vorpommern-pokal',
  },
  {
    name: 'Bremer Pokal',
    slug: 'lotto-pokal-bremen',
  },
  {
    name: 'Hamburger Pokal',
    slug: 'lotto-verbandspokal-hamburg',
  },
];

const additionalLeagues: CrawlerCompetition[] = [
  {
    name: 'Oberliga Baden-Württemberg',
    slug: 'oberliga-baden-wuerttemberg',
  },
  {
    name: 'Landesliga Mitte (Bayern)',
    slug: 'bayern-landesliga-mitte',
  },
  {
    name: 'Bayernliga Süd',
    slug: 'bayernliga-sued',
  },
  {
    name: 'Oberliga Niederrhein',
    slug: 'oberliga-niederrhein',
  },
  {
    name: 'Mittelrheinliga',
    slug: 'mittelrheinliga',
  },
  {
    name: 'Oberliga Rheinland-Pfalz/Saar',
    slug: 'oberliga-rheinland-pfalz-saar',
  },
  {
    name: 'Bayernliga Nord',
    slug: 'bayernliga-nord',
  },
  {
    name: 'Landesliga Südost (Bayern)',
    slug: 'bayern-landesliga-suedost',
  },
  {
    name: 'Landesliga Südwest (Bayern)',
    slug: 'bayern-landesliga-suedwest',
  },
  {
    name: 'Landesliga Nordost (Bayern)',
    slug: 'bayern-landesliga-nordost',
  },
  {
    name: 'Landesliga Nordwest (Bayern)',
    slug: 'bayern-landesliga-nordwest',
  },
  {
    name: 'Saarland-Liga',
    slug: 'saarlandliga',
  },
  {
    name: 'Bezirksliga Ost',
    slug: 'bezirksliga-ost-niederbayern',
  },
  {
    name: 'Bezirksliga West',
    slug: 'bezirksliga-west-niederbayern',
  },
  {
    name: 'NOFV Oberliga Süd',
    slug: 'nofv-oberliga-sued',
  },
  {
    name: 'Bezirksliga Oberpfalz Süd',
    slug: 'bezirksliga-oberpfalz-sued',
  },
  {
    name: 'Verbandsliga Württemberg',
    slug: 'verbandsliga-wuerttemberg',
  },
  {
    name: '3. Liga',
    slug: '3-liga',
  },
  {
    name: '2. Bundesliga',
    slug: '2-bundesliga',
  },
  {
    name: 'Bundesliga',
    slug: 'bundesliga',
  },
];

export {additionalLeagues, topLeagues, topCups};
